import {cleanFields} from '../../../utilities/helper/cleanFields';
import {toEnglishDigits} from '../../../utilities/helper/toEnglishNumber';
import request from '../../axios';

const PatchFertilizerAdvertisement = async (
  payload: IFertilizerAdvertisementPayload,
  guid?: string,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || null,
    type: payload?.type?.value,
    ad_price: payload.price_on_call ? null : payload.ad_price,
    price_on_call: payload?.price_on_call || false,
    has_discount: payload?.has_discount ? true : false,
    produce_year:
      payload?.produce_year && payload?.produce_year?.guid !== 'last'
        ? payload?.produce_year?.title
        : null,
    before_year: payload?.produce_year?.guid === 'last' ? 'True' : null,
    expire_year:
      payload?.produce_year?.guid !== 'last' &&
      payload?.produce_year &&
      payload?.expire_year
        ? (
            Number(toEnglishDigits(String(payload?.expire_year?.guid))) +
            Number(toEnglishDigits(String(payload?.produce_year?.title)))
          ).toString()
        : null,
    producing_country: payload?.producing_country?.guid || null,
    company: payload?.company || null,
    profile_type: 'supplier',
    attributes: payload.attributes ? payload.attributes : null,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    filter: 'advertisement',
    only_massage_buyer: payload.only_massage_buyer || false,
    discount_amount: payload?.discount_amount || null,
    images_id:
      payload?.images
        ?.map(item => item)
        .join(',')
        .toString() || null,
    main_image_id: payload?.main_image || null,
    sub_brand_main_image: payload?.sub_brand_main_image,
    ...(payload?.sub_brand && {sub_brand: payload?.sub_brand}),
    ...(payload?.sub_brand_images && {
      sub_brand_images: payload?.sub_brand_images,
    }),
    quantity_pack: payload?.quantity_pack || null,
    quantity_pack_unit: payload?.quantity_pack_unit?.value || null,
    available_quantity: payload.available_quantity || null,
    min_sell_quantity: payload?.min_sell_quantity || null,
    application_method: payload?.application_method || null,
    combinations: payload?.combinations || null,
  };
  // ✅ specify which fields to check/remove if null
  const cleanedPayload = cleanFields(newPayload, ['attributes']);

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...cleanedPayload,
  });

  return response.data;
};

export default PatchFertilizerAdvertisement;
